import { constants, typographyStyles } from "@newsela/angelou";

const { colors } = constants;

export const collapseTitleContainer = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  backgroundColor: colors.brand.neutral[25],
  borderRadius: "8px",
  marginBottom: "16px",
  ...typographyStyles.fontFamily.circular,
  ...typographyStyles.heading3,
};

export const collapseLabel = {
  fontWeight: 700,
  marginLeft: "16px",
  color: colors.ui.black[700],
};

export const subTopicsCounterLabel = {
  fontWeight: 400,
  marginLeft: "-8px",
};

export const collapseButton = {
  marginRight: "24px",
};

export const collapseContainer = {
  width: "100%",
};

export const collapseStyle = {
  Button: {
    root: collapseContainer,
  },
  root: {
    "& label": {
      paddingInline: 0,
    },
  },
};
